var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M409.3,778.6c-102.3,0-193.2-34.1-261.4-108C74.1,596.8,40,511.6,40,409.3C40,307,74.1,216.1,148,148 C221.8,74.1,307,40,409.3,40s193.2,34.1,261.4,108c73.9,73.9,108,159.1,108,261.4c0,39.8-5.7,79.5-17,119.3 c-11.4,39.8-28.4,68.2-56.8,96.6L1023,943.4c11.4,11.4,17,22.7,17,39.8c0,17-5.7,28.4-17,39.8c-11.4,11.4-22.7,17-39.8,17 c-17,0-28.4-5.7-39.8-17L625.2,704.8c-28.4,22.7-62.5,39.8-96.6,56.8C488.9,773,449.1,778.6,409.3,778.6z M409.3,665 c68.2,0,130.7-22.7,181.8-73.9s73.9-108,73.9-181.8s-22.7-130.7-73.9-181.8s-108-73.9-181.8-73.9s-130.7,22.7-181.8,73.9 s-73.9,108-73.9,181.8s22.7,130.7,73.9,181.8S335.5,665,409.3,665z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.33c23d543d9c645178c710fbeeebdafe.svg";
export { ForwardRef as ReactComponent };